import { FC, useMemo } from "react";

import {
  DirectionEnum,
  IRideRoute,
  isLiveMapRenderableRideRoute,
  LiveMapDisplayModeEnum,
} from "@ryde/shared";

import { routeIdentityKey } from "../../route-block/route-block.resolver.utils";
import { MapLibreRouteResolver } from "./maplibre-route-resolver";

interface IMapLibreRouteBlockContentProps {
  routes: IRideRoute[] | undefined;
  direction?: DirectionEnum;
  liveMapDisplayMode?: LiveMapDisplayModeEnum;
  /** Crowded map — draw stations as GPU circles instead of one HTML marker per stop. */
  isCrowdedMap?: boolean;
}

export const MapLibreRouteBlockContent: FC<IMapLibreRouteBlockContentProps> = ({
  routes,
  direction,
  liveMapDisplayMode,
  isCrowdedMap,
}) => {
  const routesWithLocations = useMemo(() => {
    if (!routes) {
      return [];
    }

    return routes.filter(isLiveMapRenderableRideRoute);
  }, [routes]);

  return routesWithLocations.map(route => (
    <MapLibreRouteResolver
      key={routeIdentityKey(route)}
      route={route}
      direction={route.direction ?? direction}
      liveMapDisplayMode={liveMapDisplayMode}
      isCrowdedMap={isCrowdedMap}
    />
  ));
};
